import { ID_REGEX } from 'constants/RegExs'

export const getMetricPathname = () => {
  const { pathname = '', hash = '' } = window.location
  return pathname.replace(ID_REGEX, ':id') + hash
}
